
import { defineComponent } from "vue";
import BarraLateral from "@/components/BarraLateral.vue";
import FormularioPrincipal from "@/components/FormularioPrincipal.vue";
import TarefaVue from "./components/TarefaVue.vue";
import ITarefa from "./interfaces/ITarefa";
import BoxVue from "./components/BoxVue.vue";

export default defineComponent({
  name: "App",
  components: { BarraLateral, FormularioPrincipal, TarefaVue, BoxVue },
  data() {
    return {
      tarefas: [] as ITarefa[],
      modoEscuroAtivo: false
    };
  },
  methods: {
    salvarTarefa(tarefa: ITarefa) {
      this.tarefas.push(tarefa);
    },
    trocarTema(modoEscuroAtivo : boolean){
      this.modoEscuroAtivo = modoEscuroAtivo;
    }
  },
  computed:{
    listaEstaVazia() : boolean{
      return this.tarefas.length == 0 //Retorna true se a lista estiver vazia
    }
  }
});
